module.exports = __webpack_public_path__ + "06_long_black.e5292fee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/06_long_black.png
// module id = dftd
// module chunks = 0